import React from 'react';
import './CaseDetail.css';

const CaseDetail = ({ caseData, onClose }) => {
  return (
    <div className="case-detail">
      <div className="case-header">
        <h2>{caseData.title}</h2>
        <button onClick={onClose}>Close</button>
      </div>
      <div className="case-content">
        <p>Case details coming soon...</p>
      </div>
    </div>
  );
};

export default CaseDetail; 